import { Button, CompassIcon, Modal, localize } from '@spacegame/ui';
import { useTutorial } from './TutorialProvider';

const COPY = {
  title: { de: 'Willkommen, Kommandant', en: 'Welcome, commander' },
  body: {
    de: 'Bevor es losgeht: eine kurze geführte Tour zeigt dir das Cockpit in zwei Minuten, oder du blätterst direkt selbst durchs Hilfe-Center. Beides bleibt jederzeit über den Fragezeichen-Knopf erreichbar.',
    en: 'Before you dive in: a short guided tour shows you the cockpit in two minutes, or browse the Help Center yourself right away. Both stay reachable any time via the question-mark button.',
  },
  tour: { de: 'Geführte Tour starten', en: 'Start guided tour' },
  help: { de: 'Hilfe-Center öffnen', en: 'Open Help Center' },
  skip: { de: 'Später, ich schaue mich selbst um', en: 'Later, I\'ll explore myself' },
} as const;

/** First-run screen — offered once per device, never forced. */
export function WelcomeModal() {
  const tutorial = useTutorial();
  const t = (entry: (typeof COPY)[keyof typeof COPY]) => localize(entry, tutorial.locale);

  return (
    <Modal open={tutorial.showWelcome} onClose={tutorial.dismissWelcome} size="sm" dismissible>
      <div className="flex flex-col items-center gap-3 py-2 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-silicate/40 bg-silicate/12 text-silicate-bright">
          <CompassIcon size={24} />
        </div>
        <h2 className="font-display text-sm font-semibold uppercase tracking-[0.12em] text-content">{t(COPY.title)}</h2>
        <p className="text-xs leading-relaxed text-content-secondary">{t(COPY.body)}</p>
        <div className="mt-2 flex w-full flex-col gap-2">
          <Button
            variant="primary"
            fullWidth
            onClick={() => {
              tutorial.dismissWelcome();
              tutorial.startTour();
            }}
          >
            {t(COPY.tour)}
          </Button>
          <Button
            variant="secondary"
            fullWidth
            onClick={() => {
              tutorial.dismissWelcome();
              tutorial.openHelp();
            }}
          >
            {t(COPY.help)}
          </Button>
          <Button variant="ghost" fullWidth onClick={tutorial.dismissWelcome}>
            {t(COPY.skip)}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
